export const products = [
  {
    id: "2375851042006",
    productCode: "2375851042006",
    gtin: "",
    name: "DOREZA ASSAULT BLACK/RED S",
    brand: "",
    description: null,
    productUrl: null,
    price: 38,
    oldPrice: 31,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg",
    imageUrls: [
      "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg"
    ],
    storeStockQuantity: 0,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "2375851042007",
    productCode: "2375851042007",
    gtin: "",
    name: "DOREZA ASSAULT BLACK/RED M",
    brand: "",
    description: null,
    productUrl: null,
    price: 40,
    oldPrice: 38,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg",
    imageUrls: [
      "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg"
    ],
    storeStockQuantity: 3,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "2375851042008",
    productCode: "2375851042008",
    gtin: "",
    name: "DOREZA ASSAULT BLACK/RED L",
    brand: "",
    description: null,
    productUrl: null,
    price: 40,
    oldPrice: 38,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg",
    imageUrls: [
      "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg"
    ],
    storeStockQuantity: 0,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "2375851042009",
    productCode: "2375851042009",
    gtin: "",
    name: "DOREZA ASSAULT BLACK/RED XL",
    brand: "",
    description: null,
    productUrl: null,
    price: 40,
    oldPrice: 38,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg",
    imageUrls: [
      "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg"
    ],
    storeStockQuantity: 1,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "2375851042010",
    productCode: "2375851042010",
    gtin: "",
    name: "DOREZA ASSAULT BLACK/RED XXL",
    brand: "",
    description: null,
    productUrl: null,
    price: 40,
    oldPrice: 38,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg",
    imageUrls: [
      "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg"
    ],
    storeStockQuantity: 1,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "2375851042011",
    productCode: "2375851042011",
    gtin: "",
    name: "DOREZA ASSAULT BLACK/RED 3XL",
    brand: "",
    description: null,
    productUrl: null,
    price: 38,
    oldPrice: 38,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg",
    imageUrls: [
      "https://www.adventurerider.co.uk/media/catalog/product/cache/059381bd7ffb1f896f935f29bf8190e8/2/3/2375851042_1.jpg"
    ],
    storeStockQuantity: 0,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "1896745",
    productCode: "1896745",
    gtin: "",
    name: "DAINESE T-SHIRT",
    brand: "",
    description: null,
    productUrl: null,
    price: 33,
    oldPrice: 33,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://dainese-cdn.thron.com/delivery/public/image/dainese/7b490a35-baa7-4f54-b929-7eb14c240dba/px6qct/std/1920xundefined/201896745_601_F.jpeg?format=webp&quality=auto-medium",
    imageUrls: [
      "https://dainese-cdn.thron.com/delivery/public/image/dainese/7b490a35-baa7-4f54-b929-7eb14c240dba/px6qct/std/1920xundefined/201896745_601_F.jpeg?format=webp&quality=auto-medium"
    ],
    storeStockQuantity: 0,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },


  {
    id: "37614207140",
    productCode: "37614207140",
    gtin: "",
    name: "BLUZ BRAAP",
    brand: "",
    description: "",
    productUrl: null,
    price: 25,
    oldPrice: 0,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://cdn.motoabbigliamento.it/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/m/a/maglia_cross_alpinestars_racer_braap_blu_navy_arancio.jpg",
    imageUrls: [
      "https://cdn.motoabbigliamento.it/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/m/a/maglia_cross_alpinestars_racer_braap_blu_navy_arancio.jpg"
    ],
    storeStockQuantity: 1,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "2786101236007",
    productCode: "2786101236007",
    gtin: "",
    name: "DOREZA PODIUM 450 BLACK/GOLD M",
    brand: "",
    description: "",
    productUrl: null,
    price: 32,
    oldPrice: 0,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.motocrosscenter.com/shop/904857-tm_thickbox_default/offer-gloves-scott-450-podium-colour-black.jpg",
    imageUrls: [
      "https://www.motocrosscenter.com/shop/904857-tm_thickbox_default/offer-gloves-scott-450-podium-colour-black.jpg"
    ],
    storeStockQuantity: 1,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "2786101236008",
    productCode: "2786101236008",
    gtin: "",
    name: "DOREZA PODIUM 450 BLACK/GOLD L",
    brand: "",
    description: "",
    productUrl: null,
    price: 32,
    oldPrice: 0,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.motocrosscenter.com/shop/904857-tm_thickbox_default/offer-gloves-scott-450-podium-colour-black.jpg",
    imageUrls: [
      "https://www.motocrosscenter.com/shop/904857-tm_thickbox_default/offer-gloves-scott-450-podium-colour-black.jpg"
    ],
    storeStockQuantity: 0,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "2786111019008",
    productCode: "2786111019008",
    gtin: "",
    name: "DOREZA 450 ANGLED GREY/BLACK L",
    brand: "",
    description: "",
    productUrl: null,
    price: 32,
    oldPrice: 0,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.motocrosscenter.com/shop/904858-tm_thickbox_default/gloves-scott-450-angled-colour-grey-black.jpg",
    imageUrls: [
      "https://www.motocrosscenter.com/shop/904858-tm_thickbox_default/gloves-scott-450-angled-colour-grey-black.jpg"
    ],
    storeStockQuantity: 1,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "8018080314025",
    productCode: "8018080314025",
    gtin: "",
    name: "BLUETOOTH CELULARLINE SHAPE",
    brand: "",
    description: "",
    productUrl: null,
    price: 170,
    oldPrice: 0,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.motorstock.it/44269-thickbox_default/interphone-shape-pack-double-intercom-for-bluetooth-motorcycle.jpg",
    imageUrls: [
      "https://www.motorstock.it/44269-thickbox_default/interphone-shape-pack-double-intercom-for-bluetooth-motorcycle.jpg"
    ],
    storeStockQuantity: 2,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "35625211448",
    productCode: "35625211448",
    gtin: "",
    name: "DOREZA ALPINESTAR DUNE",
    brand: "",
    description: "",
    productUrl: null,
    price: 22,
    oldPrice: 0,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://cdn.motoabbigliamento.it/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/g/u/guanti_cross_alpinestars_dune_grigio_arancio_2.jpg",
    imageUrls: [
      "https://cdn.motoabbigliamento.it/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/g/u/guanti_cross_alpinestars_dune_grigio_arancio_2.jpg"
    ],
    storeStockQuantity: 1,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "356402012",
    productCode: "356402012",
    gtin: "",
    name: "DOREZA ALPINESTAR SMX (X)",
    brand: "",
    description: "",
    productUrl: null,
    price: 35,
    oldPrice: 0,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.mdracingproducts.co.uk/media/amasty/webp/catalog/product/cache/5f305f0123a97be44e2d540498980a2b/3/5/356402-012-01_jpg.webp",
    imageUrls: [
      "https://www.mdracingproducts.co.uk/media/amasty/webp/catalog/product/cache/5f305f0123a97be44e2d540498980a2b/3/5/356402-012-01_jpg.webp"
    ],
    storeStockQuantity: 0,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "37600211344",
    productCode: "37600211344",
    gtin: "",
    name: "BLUZ ALPINESTAR TECHSTAR VENOM",
    brand: "",
    description: "",
    productUrl: null,
    price: 49,
    oldPrice: 0,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.parismotostore.com/wp-content/uploads/2025/09/37600211344_78736520.webp",
    imageUrls: [
      "https://www.parismotostore.com/wp-content/uploads/2025/09/37600211344_78736520.webp"
    ],
    storeStockQuantity: 4,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "350952010",
    productCode: "350952010",
    gtin: "",
    name: "DOREZA ALPINESTAR GARETH",
    brand: "",
    description: "",
    productUrl: null,
    price: 45,
    oldPrice: 0,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.motostorm.it/images/products/large/guanti/alpinestars_garethleathergloves_nero.jpg",
    imageUrls: [
      "https://www.motostorm.it/images/products/large/guanti/alpinestars_garethleathergloves_nero.jpg"
    ],
    storeStockQuantity: 0,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "35690201119",
    productCode: "35690201119",
    gtin: "",
    name: "DOREZA ALPINESTAR RACER SUPERMATIC",
    brand: "",
    description: "",
    productUrl: null,
    price: 45,
    oldPrice: 38,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.motosgarrido.com/11211-zoom/guantes-alpinestars-smx-1-air-v2-negro.jpg",
    imageUrls: [
      "https://www.motosgarrido.com/11211-zoom/guantes-alpinestars-smx-1-air-v2-negro.jpg"
    ],
    storeStockQuantity: 0,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "HE8910EBLKXL",
    productCode: "HE8910EBLKXL",
    gtin: "",
    name: "HELMETA SHARK EVO GT BLANK  XL",
    brand: "",
    description: "",
    productUrl: null,
    price: 380,
    oldPrice: 0,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://www.shark-helmets.com/cdn/shop/files/HE8910EBLK_SHARK-HELMETS-EVO-GT-BLANK-BLACK_ps_01.png?v=1759289630&width=600",
    imageUrls: [
      "https://www.shark-helmets.com/cdn/shop/files/HE8910EBLK_SHARK-HELMETS-EVO-GT-BLANK-BLACK_ps_01.png?v=1759289630&width=600"
    ],
    storeStockQuantity: 1,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  },
  {
    id: "HE8915EABKXL",
    productCode: "HE8915EABKXL",
    gtin: "",
    name: "HELMETA SHARK EVO GT ENCKE MAT XL",
    brand: "",
    description: "",
    productUrl: null,
    price: 0,
    oldPrice: 0,
    currency: "€",
    category: "WEB",
    categories: ["WEB"],
    image: "https://data.outletmoto.eu/imgprodotto/modular-motorcycle-helmet-in-shark-evo-gt-encke-anthracite-blue-matt-black_131804_zoom.jpg",
    imageUrls: [
      "https://data.outletmoto.eu/imgprodotto/modular-motorcycle-helmet-in-shark-evo-gt-encke-anthracite-blue-matt-black_131804_zoom.jpg"
    ],
    storeStockQuantity: 0,
    storeSupplierQuantity: 0,
    specifications: [],
    variants: null
  }
];